// export const BaseIp = 'http://192.168.29.113:2001/' //---local path (URL)
export const BaseIp = 'https://boarding.jainboardingkolhapur.com/'     //---online path (URL)

export const IMG_BASE_URL = BaseIp + 'uploads/' //---img path (URL)
export const IMG_BASE_URL1 = BaseIp + 'complaint_img/' //---img path (URL)
export const IMG_BASE_URL2 = BaseIp + 'certificate_pdfs/' //---View Certificate PDF path (URL)
export const IMG_BASE_URL3 = BaseIp + 'alumini_img/' //---alumni img path (URL)

//=======================================================================================================
//=======================================================================================================

export const LoginAPI = BaseIp + 'admin/adminLogin' //ADMIN LOGIN API (POST)





//change pass api
//http://192.168.29.113:2001/admin/changePassword
export const changePasswordAdmin = BaseIp + 'admin/changePassword'

export const BranchMaster = BaseIp + 'branch/getAllBranch' //Get Branch Master (GET)
export const BranchMasterById = BaseIp + 'branch/getBranch' //Get Branch Master By Id (GET) (params => branch_id)
export const AdminMaster = BaseIp + 'admin/getAllAdmin' //Get Admin Master (GET)
export const BoardingYear = BaseIp + 'admin/BoardingYear' //Get Boarding Year (GET)
export const CheckBedsAvailability = BaseIp + 'bed/checkBedsAvailable' //Check Bed Available Or Not (POST)

export const DashboardList = BaseIp + 'dashboard/dashboardDetails' //Dashboard List (GET) (params => branch_id)
export const RegControlOfBranchMaster = BaseIp + 'branch/onOffBranch' //Reg. Control (ON-OFF) (PUT) (params => branch_id)

// =======Registration Form===========================
export const RegFormApprovedList = BaseIp + 'registration/regFormApproval' //Reg Form Approved List (GET) (params => branch_id)
export const RegFormApproveReject =
  BaseIp + 'registration/approveRejectRegFromAndPayment' //Reg Form Approve Reject (PUT)
export const RegFormAppPendingList =
  BaseIp + 'registration/pendingRegFormApproval' //Reg Form Appr. Pending List (GET) (params => branch_id/year)
export const getTeramsCobditionAPIURL =
  BaseIp + 'termcondition/getAllTermAndCondition/1'

//http://192.168.29.113:2001/registration/regFormRejected/1/2026
export const getRejectedSTudentList = BaseIp + 'registration/regFormRejected'

//registration 50rs fee approve/reject
// (PUT) http://localhost:2001/registration/approveRejectRegFromAndPayment
export const RegFormApproveRejectAPIURL =
  BaseIp + 'registration/approveRejectRegFromAndPayment'

//=========pending interviews list==================
// http://localhost:2001/registration/interviewSelectList
export const pendingInterviewListAPIURL =
  BaseIp + 'registration/interviewSelectList'

// /http://localhost:2001/registration/interviewPassFail
export const passedInterviewListAPIURL =
  BaseIp + 'registration/interviewPassStudentList'

////interview pass/fail
// (PUT) http://localhost:2001/registration/interviewPassFail
// {
//     "reg_id":5,
//     "interview_status":2      (2=PASS, 3=FAIL)
// }
export const pendingInterviewListPassFailAPIURL =
  BaseIp + 'registration/interviewPassFail'

// *********FEE CONCESSION************
//http://192.168.29.113:2001/registration/studentConcession
export const StudentFeeConcession = BaseIp + 'registration/studentConcession' //Student Fee Concession Approve  (POST)
export const ConcessionFeeApprovedList =
  BaseIp + 'registration/concessionStudent' //Student Fee Concession Approved Students List  (GET) (params=>id and year)

// =======Hostel Fee Approval Form===========
export const GetFeeApprovedList = BaseIp + 'hostel_fee/hostelFeeApprovalList' //Hostel Fee Approved List (GET) (params => branch_id/year)
export const FeeApproveReject =
  BaseIp + 'hostel_fee/hostelFeeApproveAndRejectPayment' //Hostel Fee Approve Reject (PUT)
export const GetFeeAppPendingList =
  BaseIp + 'hostel_fee/pendingHostelFeeApproval' //Hostel Fee Appr. Pending List (GET) (params => branch_id)


  export const pendingRoomAllotmentList = BaseIp + 'hostel_fee/pendingRoomAllotment'    // room allotment pending list GET (params=> branch_id and year)

  export const allotRoom = BaseIp +  'hostel_fee/allotRoom'
// ********** Get Available Room ***********
export const GetAvailableRoom = BaseIp + 'room/getAvailableRoom' //Get Available Room Data (GET) (params => class_id)

//Room allocation List
//  http://192.168.29.113:2001/hostel_fee/StudentRoomBookedData/1/2026
export const getRoomAllocationList = BaseIp + 'hostel_fee/StudentRoomBookedData'

// change room      //change-student-room
// export const ChangeStudentRoomAPI = BaseIp + 'hostel_fee/change-student-room'

//=========pending Document list==================
export const getDocumentPendingList = BaseIp + 'document/pending-document-list'

//=========rejected Document list==================
export const getDocumentRejectList = BaseIp + 'document/rejected-document-list'

//=========Approved Document list==================
export const getDocumentApprovedList = BaseIp + 'document/approved-document-list'

//=========Approve / Reject Document ==================
export const DocumentApproveReject = BaseIp + 'document/approve-reject-document'


//======Leave Approval Form=======================
export const GetLeaveApprovedList =
  BaseIp + 'leave/getAllApprovalLeaveStudentByBranch' // Leave Approved List (GET) (params => branch_id/year)
export const GetPendingLeaveList =
  BaseIp + 'leave/getAllPendingLeaveStudentByBranch' //Create Leave Application (GET) (params=> branch_id/year)
export const UpdateApproveRejectLeave =
  BaseIp + 'leave/approveRejectLeaveApplication' //Create Leave Application (PUT) (params=> id) (2=approve, 3=reject)

// =====Generate Certificate========================
export const GetCasteCertificateData =
  BaseIp + 'certificate/getAllStudentBranchWise' //Generate Certificate (GET) (params=> branch_id & year)
export const GenerateCertificate = BaseIp + 'certificate/generateCertificate' //Generate Certificate (POST)
export const UpdateCertificate = BaseIp + 'certificate/updateCertificate' //Update Certificate (PUT) (params=> id)

//======Complaint Approval Form==========
export const GetAppComplaintList = BaseIp + 'complaint/getAllBranchComplaint' //Complaint Approval List (GET) (params=> branch_id/year)
export const GetPendingComplaintList =
  BaseIp + 'complaint/getAllPendingComplaint' //Complaint Approval Pending List (GET) (params=> branch_id/year)
export const UpdateApproveRejectComplaint =
  BaseIp + 'complaint/resolveRejectComplaint' //Complaint Approve-Reject List (GET) (params=> id)

//========Room Change By Admin===============
export const ApplyRoomChange = BaseIp + 'roomchange/applyroomChange' //Apply for Room Change (PUT)
export const RoomChangeHistory = BaseIp + 'roomchange/roomChangeHistory' //Room Changed History (GET) (params=> branch_id/year)
export const AvailableRoomsData = BaseIp + 'room/getRoomDataByClassWise' // Available Rooms (For Room Change) (GET) (params=> class_id)
// export const RoomAllocationList

//=========Student Attendance===========================

// -------Daily Attendance------------
export const GetStudentListForAttendance =
  BaseIp + 'daily-attendance/hostelFeeApprovalListForDailyAttendance' //Student List For Attendance (GET)(params=> branch_id/year)
export const StudentAttendanceMorning =
  BaseIp + 'daily-attendance/morningAttendance' //Morning Attendance (POST) (params=> branch_id/year)
export const StudentAttendanceNight =
  BaseIp + 'daily-attendance/nightAttendance' //Night Attendance (POST)

export const GetStudentAttendedList =
  BaseIp + 'daily-attendance/getAllAttendace' //Student Attendance List  (GET)(params=> branch_id/year)

// -------Event Attendance------------
export const GetStudentListForEventAttendance =
  BaseIp + 'event_attendance/hostelFeeApprovalListForEventAttendance' //Student List For Attendance (GET)(params=> branch_id/year)

export const SaveStudentEventAttendance =
  BaseIp + 'event_attendance/createAttendance' //Student Attendance for EVENT (POST)

export const GetEventAttendedList =
  BaseIp + 'event_attendance/getAllEventAttendace' //Student Attendance List  (POST)(params=> branch_id/year)

// -------Mandir Attendance------------
export const GetStudentListForMandirAttendance =
  BaseIp + 'mandir-attendance/hostelFeeApprovalListForMandirAttendance' //Student List For Mandir Attendance (GET)(params=> branch_id/year)
export const SaveStudentMandirAttendance =
  BaseIp + 'mandir-attendance/mandirAttendance' //Create Mandir Attendance (POST)

export const GetMandirAttendedList =
  BaseIp + 'mandir-attendance/getAllMandirAttendanceBranchWise' //Student Attendance List  (GET)(params=> branch_id/year)

// =======MASTERS API====================================================================

//=======Class Master==============
export const CreateClassMaster = BaseIp + 'class/createClass' //Create Class Master (POST)
export const GetClassMaster = BaseIp + 'class/getAllClassData' //Get Class Master (GET) (params=> branch_id)
export const UpdateClassMaster = BaseIp + 'class/updateClassData' //Update Class Master (PUT) (params=> branch_id)
export const UpdateClassStatus = BaseIp + 'class/updateClassStatus' //Update Class Status (PUT)

//=======Room Master==============
export const GetRoomMaster = BaseIp + 'room/getAllRoomData' //Get Room Master (GET) (params=> branch_id)
export const GetRoomMasterById = BaseIp + 'room/getRoomById' //Get Room Master BY ID (GET) (params => branch_id)
export const CreateRoomMaster = BaseIp + 'room/createRoom' //Create Room Master (POST)
export const UpdateRoomMaster = BaseIp + 'room/updateRoom' //Update Room Master (PUT) (params => room_id)

export const UpdateRoomStatus = BaseIp + 'room/updateRoomStatus' //Update Room Status (PUT)

//=======Bed Master==============
export const GetBedMaster = BaseIp + 'bed/allBed' //Get Bed Master (GET) (params=> branch_id)
export const GetBedMasterById = BaseIp + 'bed/getBedById' //Get Bed Master (GET) (params => /branch_id/room_id)
export const CreateBedMaster = BaseIp + 'bed/createBed' //Create Bed Master (POST)
export const UpdateBedMaster = BaseIp + 'bed/updateBed' //Update Bed Master (PUT) (params => bed_id)

export const UpdateBedStatus = BaseIp + 'bed/updateBedStatus' //Update Bed Status (PUT)

//=======Religion Master==============
export const GetReligionMaster = BaseIp + 'religion/getAllReligion' //Get Religion Master (GET)
export const CreateReligionMaster = BaseIp + 'religion/addReligion' //Create Religion Master (POST)
export const UpdateReligionMaster = BaseIp + 'religion/updateReligion' //Update Religion Master (PUT) (params => religion_id)

//=======Caste Master==============
export const GetCasteMaster = BaseIp + 'cast/getAllCast' //Get Caste Master (GET)
export const GetCasteMasterById = BaseIp + 'cast/getCastByIdReligionWise' //Get Caste Master (GET)  (params => religion_id)
export const CreateCasteMaster = BaseIp + 'cast/createCast' //Create Caste Master (POST)
export const UpdateCasteMaster = BaseIp + 'cast/updateCast' //Update Caste Master (PUT) (params => caste_id)

//=======Sub-Caste Master==============
export const GetSubCasteMaster = BaseIp + 'subcast/getAllSubCast' //Get SubCaste Master (GET)
export const GetSubCasteMasterById = BaseIp + 'subcast/getSubCastById' //Get SubCaste Master BY ID (GET) (params => caste_id)
export const CreateSubCasteMaster = BaseIp + 'subcast/createSubCast' //Create SubCaste Master (POST)
export const UpdateSubCasteMaster = BaseIp + 'subcast/updateSubCast' //Update SubCaste Master (PUT) (params => caste_id)
export const DeleteSubCasteMaster = BaseIp + 'subcast/deleteSubCast' //Delete SubCaste Master (DELETE) (params => subcaste_id)

//=======Fee Master==============
export const GetFeeMaster = BaseIp + 'feemaster/getAllFeeBranchWise' //Get Fee Master (GET) (params => branch_id)
export const CreateFeeMaster = BaseIp + 'feemaster/createFeeMaster' //Create Fee Master (POST)
export const UpdateFeeMaster = BaseIp + 'feemaster/updateFeeMaster' //Update Fee Master (PUT) (params => fee_id)

//=======Fee Amount Master==============
export const GetFeeAmountMaster =
  BaseIp + 'feeamountmaster/getFeeAmountBranchWise' //Get FeeAmount Master (GET) (params => branch_id/year)
export const CreateFeeAmountMaster = BaseIp + 'feeamountmaster/createFeeAmount' //Create FeeAmount Master (POST)
export const UpdateFeeAmountMaster = BaseIp + 'feeamountmaster/updateFeeAmount' //Update FeeAmount Master (PUT) (params => fee_amt_id)
export const DeleteFeeAmountMaster = BaseIp + 'feeamountmaster/deleteFeeAmount' //Delete FeeAmount Master (DELETE) (params => fee_amt_id)

//=======Event Master==============
export const GetEventMaster = BaseIp + 'event_master/getAllEvent' //Get Event Master (GET) (params => branch_id/year)
export const CreateEventMaster = BaseIp + 'event_master/createEvent' //Create Event Master (POST)
export const UpdateEventMaster = BaseIp + 'event_master/updateEvent' //Update Event Master (PUT) (params => event_id)
export const DeleteEventMaster = BaseIp + 'event_master/deleteEvent' //Delete Event Master (DELETE) (params => event_id)

//=======Terms & Condition Master==============
export const GetTermsConditionMaster =
  BaseIp + 'termcondition/getAllTermAndCondition' //Get Terms and condition Master (GET) (params => branch_id)
export const CreateTermsConditionMaster =
  BaseIp + 'termcondition/addTermAndCondition' //Create Terms and condition Master (POST)
export const UpdateTermsConditionMaster =
  BaseIp + 'termcondition/updateTermAndCondition' //Update Terms and condition Master (PUT) (params => id)
export const DeleteTermsConditionMaster =
  BaseIp + 'termcondition/deleteTermAndCondition' //Delete Terms and condition Master (DELETE) (params => id)

//======= Job Category Master==============
export const GetJobCategorysMaster =
  BaseIp + 'jobcategory_master/getAllCategory' //Create Job Category Master (POST)
export const CreateJobCategoryMaster =
  BaseIp + 'jobcategory_master/createJobCategory' //Get Job Category Master (GET) (params=> branch_id)
export const UpdateJobCategoryMaster =
  BaseIp + 'jobcategory_master/updateCategory' //Update Job Category Master (PUT) (params=> branch_id)
export const DeleteJobCategoryStatus =
  BaseIp + 'jobcategory_master/deleteCategory' //Update Job Category Status (PUT)

// ======== ALUMNI =======================
export const GetAlumniProfile = BaseIp + 'alumini/getAluminiBySignUpId' //Get Alumni Profile Data (GET) (params=> signup id)

export const AlumniSignUp = BaseIp + 'alumini/aluminiSignUp' //Alumni Sign Up (POST)
export const AlumniLoginAPI = BaseIp + 'alumini/aluminiLogin' //Alumni Login (POST)
export const AlumniCreateAPI = BaseIp + 'alumini/createAlumini' //Alumni Create (POST)
export const AlumniJobCreateAPI = BaseIp + 'alumini/createAlumini' //Alumni Job Create (POST)

export const AlumniApprovalPendingList =
  BaseIp + 'alumini/getAllPendingAluminisList' //Alumni Approval Pending List (GET)
export const AlumniAppList = BaseIp + 'alumini/getAllApprovalAluminisList' //Alumni Approved List (GET)
export const AlumniApproveReject = BaseIp + 'alumini/approveRejectAlumini' //Alumni Approve/Reject (POST) (params=> id)

export const AlumniForgotPassword = BaseIp + 'alumini/forgotPassword' //Alumni Forgot Password (POST)
export const AlumniResetPassword = BaseIp + 'alumini/resetPassword' //Alumni Reset Password (POST)

// ======== ALUMNI JOB POST =======================
export const GetJobPostByAlumni = BaseIp + 'job_posts/getAllJobPostByAlumini' //Get Job Post By Alumni Id (GET) (params=> signup id / year)
export const GetJobPost = BaseIp + 'job_posts/getAllJobPost' //Get Job Post (GET) (params=> year)
export const CreateJobPost = BaseIp + 'job_posts/createJobPost' //Create Job Post (POST)
export const DeleteJobPost = BaseIp + 'job_posts/deleteJobPost' //Delete Job Post (DELETE) (params=> id)
